import { IAction, KEEP_THE_SAME, StateStatus } from 'redux/utils/common';
import * as Types from './type';
import * as ClientService from 'services/api/client';
import { LanguagesEnum } from 'constants/languages';
import { INote } from 'constants/notes';

export interface IState {
  createNote: StateStatus | null | undefined;
  clientNotes: {
    data: Array<INote>;
    status: StateStatus | null | undefined;
  };
  deleteNoteStatus: StateStatus | null | undefined;
}

const initialState: IState = {
  createNote: null,
  clientNotes: {
    data: [],
    status: null,
  },
  deleteNoteStatus: null,
};

const ClientNotesReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_CLIENT_NOTES:
      return {
        ...state,
        clientNotes: {
          ...state.clientNotes,
          data:
            action.data === KEEP_THE_SAME
              ? state.clientNotes.data
              : action.data,
          status: action.status,
        },
      };
    case Types.CREATE_NOTE:
      return {
        ...state,
        createNote: action.status,
      };
    case Types.DELETE_NOTE:
      return {
        ...state,
        deleteNoteStatus: action.status,
      };
    default:
      return {
        ...state,
      };
  }
};

export default ClientNotesReducer;
